import { Grid, Typography } from "@mui/material";
import MainTitle from "../../muiHome/mainTitle";
import { ListDataPresentation, TableDataPresentation } from "../../../utils/utils";
import BannerCoursesDurationFee from "../../muiCommonComponent/bannerCoursesDurationFee";
const MBA=()=>{
    const progHiglight=[
{listName:'Rigorous Curriculum: Our MBA program offers a comprehensive curriculum that covers essential topics such as finance, marketing, operations, human resources, and strategic management.'},
{listName:'Experiential Learning: Emphasis on experiential learning through case studies, simulations, industry projects, and internships to bridge the gap between theory and practice.'},
{listName:'Expert Faculty: Learn from a diverse team of experienced faculty members and industry practitioners who bring real-world insights into the classroom.'},
{listName:'Personalized Mentorship: Receive personalized mentorship and guidance to help you chart your career path and achieve your professional goals.'},
{listName:'Networking Opportunities: Access to a vast network of alumni, industry professionals, and corporate partners for networking, internships, and job placements.'},
{listName:'Leadership Development: Develop leadership skills through workshops, seminars, and leadership development programs designed to nurture future business leaders.'},
{listName:'State-of-the-Art Facilities: Study in a modern campus equipped with state-of-the-art facilities, including libraries, computer labs, seminar halls, and recreational areas.'},
{listName:'Industry Partnerships: Benefit from our strong industry partnerships that provide opportunities for industry exposure, guest lectures, and corporate mentorship programs.'},
{listName:'Holistic Development: Focus on holistic development, including communication skills, teamwork, problem-solving abilities, and ethical decision-making.'},    
    ]
    const feeStructureData=[
        {duration:'1st Year Onwards Fees','2 Years':'₹95000/- (Tuition Fee - ₹75000 + Other Charges- ₹20000/-)'},
        // {duration:'2nd Year Onwards Fees','2 Years':'₹92000/- ( Tuition Fee – ₹75000 + Other Charges- ₹20000/-)'}
    ]
    const hostalFeeData=[
        {item:'Triple Seater with Meal','fee':'₹ 96000/-'},
        {item:'Triple Seater (AC) with Meal','fee':'₹130000/-'}
    ]
    const duration='2 years'
    const fee_1st= '95,000'
    const fee_2nd= '95,000'
    const eligibility='50% in Graduation in any Discipline.'
return (
<Grid container spacing={2}>
<Grid item xs={12}>
<BannerCoursesDurationFee duration={duration} fee_1st={fee_1st} fee_2nd={fee_2nd} eligibility={eligibility}/>
    </Grid>
<Grid item xs={12}>
    <MainTitle title="MBA- Master of Business Administration" />
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="About the Program" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Explore your potential for leadership and innovation with MVN University's MBA program. Our MBA curriculum is designed to equip students with the skills and knowledge necessary to thrive in today's dynamic business environment. With a focus on experiential learning, our program blends theoretical concepts with real-world applications, ensuring that graduates are prepared to tackle the challenges of the global marketplace. Led by a team of experienced faculty members and industry experts, students engage in interactive discussions, case studies, and collaborative projects that foster critical thinking and problem-solving abilities. Whether you aspire to climb the corporate ladder, start your venture, or make a meaningful impact in the world of business, MVN University's MBA program provides the platform for you to achieve your goals. Join us and embark on a transformative journey towards success.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Eligibility" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" fontWeight={800} >
   Minimum Eligibility Criteria
    </Typography>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
50% in Graduation in any Discipline. 
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Programme Highlights" />
    </Grid>

    <Grid item xs={12}>
    <ListDataPresentation DataList={progHiglight}/>
    </Grid>

    <Grid item xs={12}>
    <MainTitle title="Fee Structure" />
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    The comprehensive fee structure is designed to be transparent, helping you and your family plan effectively for all four years of the program. Below, you will find a detailed breakdown of tuition fees, including specific costs for the first year and subsequent years.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    B.B.A.
    </Typography>
    <TableDataPresentation data={feeStructureData}/>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    Ensure your comfort and convenience while studying at our institution with our range of hostel accommodations. We offer various options to suit your preferences, including triple seater rooms, both air-conditioned and non-air-conditioned, complete with meal plans. Below, you’ll find detailed information on our hostel fee structures for each option.
    </Typography>
    </Grid>

    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" alignItems={'center'} fontWeight={800}>
    Hostel Fee
    </Typography>
    <TableDataPresentation data={hostalFeeData}/>
    </Grid>
    <Grid item xs={12}>
    <Typography textAlign='left' fontSize="14px" letterSpacing="0.5px" fontFamily="sans-serif" >
    <b>Note:</b> Hostel Caution Money of ₹10,000/- One Time Payment (Refundable)
    </Typography>
    </Grid>
    </Grid>

)
}
export default MBA;